import {
  BaseContextSelectionPanel,
  type ContextDirectory,
} from '../../components/ContextSelectionPanel/BaseContextSelectionPanel';
import type { RecommendationsTableStore } from '../RecommendationsTableStore';
import type { TRecommendationRowData } from '../types';

type ArrayField = Extract<
  {
    [K in keyof TRecommendationRowData]-?: TRecommendationRowData[K] extends (number | string)[] | undefined
      ? K
      : never;
  }[keyof TRecommendationRowData],
  string
>;

export type RecommendationContextDirectory = ContextDirectory<ArrayField>;

type Props = {
  selectedRowIds: string[];
  store: RecommendationsTableStore;
  directories: RecommendationContextDirectory[];
  title?: string;
  onClose?: () => void;
  onResetAll?: () => void;
  className?: string;
  container: HTMLElement;
};

export function RecommendationsContextPanel({
  selectedRowIds,
  store,
  directories,
  title,
  onClose,
  onResetAll,
  className,
  container,
}: Props) {
  return (
    <BaseContextSelectionPanel
      selectedRowIds={selectedRowIds}
      store={store}
      directories={directories}
      title={title}
      onClose={onClose}
      onResetAll={onResetAll}
      className={className}
      container={container}
      getFieldValue={(tableStore, rowId, fieldName) =>
        tableStore.getFieldValue(rowId, fieldName as keyof TRecommendationRowData)
      }
      applyFieldValue={(tableStore, rowId, fieldName, values, valueType) => {
        const converted = valueType === 'string' ? values.map(String) : values.map(Number);
        tableStore.onRecommendationItemValueChange(rowId, fieldName, converted);
      }}
    />
  );
}
